export const CALCULATOR_DATA_LANGUAGE_CHANGE_EVENT = "fishystuff:languagechange";

const ENUM_TRANSLATIONS = Object.freeze({
    absent: ["calculator.data.state.absent", "Absent"],
    inactiveCondition: ["calculator.data.status.condition_inactive", "Condition inactive"],
    effective: ["calculator.data.status.effective", "Effective"],
    guessed: ["calculator.data.confidence.guessed", "Guessed"],
    incompleteProvenance: ["calculator.data.unavailable.incomplete_provenance", "Incomplete provenance"],
    known: ["calculator.data.state.known", "Known"],
    member: ["calculator.data.membership.member", "Included in group"],
    missingSourceFact: ["calculator.data.unavailable.missing_source", "Missing source fact"],
    modelSelectionRequired: ["calculator.data.unavailable.model_selection", "Choose condition"],
    noEquivalentRawWeight: ["calculator.data.unavailable.no_equivalent_raw_weight", "No equivalent raw weight"],
    notApplicable: ["calculator.data.unavailable.not_applicable", "Not applicable"],
    notLoaded: ["calculator.data.state.not_loaded", "Not loaded"],
    notMember: ["calculator.data.membership.not_member", "Excluded from group"],
    overridden: ["calculator.data.status.overridden", "Overridden"],
    denormalizedWeight: ["calculator.data.rate_basis.denormalized_weight", "Denormalized"],
    perCatch: ["calculator.data.rate_basis.per_catch", "Per catch"],
    percent: ["calculator.data.rate_basis.percent", "Percent"],
    present: ["calculator.data.state.present", "Present"],
    ratio: ["calculator.data.rate_basis.ratio", "Ratio"],
    rawWeight: ["calculator.data.rate_basis.raw_weight", "Raw weight"],
    refuted: ["calculator.data.status.refuted", "Refuted"],
    unavailable: ["calculator.data.state.unavailable", "Unavailable"],
    unknown: ["calculator.data.state.unknown", "Unknown"],
    unsupportedSourceVariant: ["calculator.data.unavailable.unsupported_source", "Unsupported source variant"],
});

function formatFallback(value, variables) {
    return String(value ?? "").replace(
        /\{\s*\$([A-Za-z0-9_]+)\s*\}/g,
        (_match, name) => (
            Object.prototype.hasOwnProperty.call(variables, name)
                ? String(variables[name])
                : ""
        ),
    );
}

function languageHelper() {
    const helper = globalThis.window?.__fishystuffLanguage
        ?? globalThis.__fishystuffLanguage;
    return helper && typeof helper.t === "function" ? helper : null;
}

function documentLocale() {
    const locale = String(
        globalThis.document?.documentElement?.getAttribute?.("lang")
        ?? globalThis.document?.documentElement?.lang
        ?? "",
    ).trim();
    return locale || null;
}

export function calculatorDataText(key, fallback, variables = {}) {
    const helper = languageHelper();
    if (helper) {
        const locale = documentLocale();
        const translated = locale
            ? helper.t(key, variables, { locale })
            : helper.t(key, variables);
        if (translated !== key) {
            return String(translated);
        }
    }
    return formatFallback(fallback, variables);
}

export function calculatorDataEnumLabel(value) {
    const entry = ENUM_TRANSLATIONS[value];
    if (entry) {
        return calculatorDataText(entry[0], entry[1]);
    }
    return String(value ?? "")
        .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
        .replace(/^./, (character) => character.toUpperCase());
}

export function calculatorDataLocale(fallback = "en-US") {
    const current = languageHelper()?.current?.();
    const locale = String(current?.locale ?? "").trim();
    return locale || fallback;
}

export function calculatorDataLanguageTarget() {
    return globalThis.window ?? null;
}
